// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c9132fa","223":"3fb1c9ef","455":"1823dff2","488":"55b669a7"}[chunkId] + ".chunk.js";
};